// extracted by mini-css-extract-plugin
export var orderDetails = "_r1-2";
export var orderImage = "_r1-1";
export var orderMeta = "_r1-3";
export var orderSummary = "_r1-0";
export var rightArrow = "_r1-4";